import React from "react";
import Header from "../Components/nav";
import Footer from "../Components/footer";
import About from "../Components/about";
import Bottomfooter from "../Components/bottomfooter";
// import Form from "../Components/form";

const CompanyRoute = () => {
  return (
    <div>
      <Header active4="active" />
      <About />
      <Footer />
      {/* <Bottomfooter /> */}
    </div>
  );
};

export default CompanyRoute;
